export function isDevEnvironment(): boolean {
  return ['dev', 'test'].includes(window.sgmeConfiguration.EnvName);
}
